import { render, staticRenderFns } from "./PracticeList.vue?vue&type=template&id=530b5c80&"
import script from "./PracticeList.vue?vue&type=script&lang=js&"
export * from "./PracticeList.vue?vue&type=script&lang=js&"
import style0 from "./PracticeList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PracticeList.vue"
export default component.exports